<template>
  <table class="document-node__alt-table" :aria-labelledby="`${value.uuid}-chart-title`">
    <thead>
      <tr>
        <td></td>
        <th scope="col">
          {{ value.meta.axisLabels ? value.meta.axisLabels.y : 'label' }}
        </th>
        <th scope="col">
          {{ value.meta.axisLabels ? value.meta.axisLabels.x : 'value' }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in value.content.data" :key="`table-row-${index}`">
        <th scope="row">
          <component :href="row.labelLink" :is="row.labelLink ? 'a' : 'span'">
            {{ row.label }}
          </component>
        </th>
        <td v-for="key in ['y', 'x']" :key="`table-row-${index}-cell-${key}`">
          {{ row[key] }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

export default {
  name: 'PriorityMatrixTable',
  props: {
    value: PigeonDocNodeModel,
  },
};
</script>
